import {useRef} from "react";

function QuizLearn({question}) {
    const video = useRef()
    const audio = useRef()

    const handle = {
        video: {
            play: url => {
                video.current.src = url
                video.current.play()
            }
        },
        audio: {
            play: () => {
                video.current.src = question.video.pronunciation
                video.current.load()
                video.current.addEventListener('loadeddata', () => {
                    video.current.currentTime = video.current.duration - .5
                    audio.current.play()
                }, {once: true});
            }
        }
    }

    return (
        <div className={"quiz-learn"}>
            <div className="phrase">
                <video src={question.video.writing} ref={video}></video>
                <audio src={question.sound} ref={audio}></audio>
                <div className="actions">
                    <button className="writing" onClick={() => handle.video.play(question.video.writing)}>
                        <img src="https://s3.amazonaws.com/PandaExpressWebsite/lny/img/chinese/brush-white.svg"
                             alt="Brush"/>
                    </button>
                    <button className="sound" onClick={() => handle.video.play(question.video.pronunciation)}>
                        <img src="https://s3.amazonaws.com/PandaExpressWebsite/lny/img/chinese/sound-white.svg"
                             alt="Sound"/>
                    </button>
                    <button className="normal-speed" onClick={() => handle.audio.play()}>
                        <span className={"normal-speed-image"}><img src="https://s3.amazonaws.com/PandaExpressWebsite/lny/img/chinese/normal-speed.svg"
                             alt="Normal Speed"/>
                            </span>
                        <span>
                            <span>Listen at</span>
                            <span>Normal Speed</span>
                        </span>
                    </button>
                </div>
            </div>
        </div>
    )
}

export default QuizLearn
